<nav class='navbar navbar-default navbar-fixed-top'>
  <div class="container-fluid">
    <div class="navbar-header">
      <button type="button" class="navbar-toggle" (click)="collapsed = !collapsed">
      <span class="icon-bar" *ngFor="let iconBar of [1, 2, 3]"></span>
      </button>
      <a routerLink="/" class="navbar-brand">Cooking Papa</a>
    </div>

    <div class="navbar-collapse" [class.collapse]="collapsed" (window:resize)="collapsed = true">
      <ul class='nav navbar-nav'>
        <li routerLinkActive='active'><a routerLink='/recipes' *ngIf='authenticated'>Recipes</a></li>
        <li routerLinkActive='active'><a routerLink='/authentication' *ngIf='!authenticated'>Authenticate</a></li>
        <li routerLinkActive='active'><a routerLink='/shopping-list'>Shopping List</a></li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <li *ngIf='authenticated'>
          <a style='cursor: pointer' (click)='onLogout()'>Logout</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
